import { Clock } from 'lucide-react';
import { StatusBadge } from '@/components/status-badge';
import type { WaitBand } from '../api/support';
import { WAIT_TONE } from '../wait-band';

/** Espera legível: "12 min", "2 h 5 min", "3 dias". */
function formatWait(minutes: number): string {
  if (minutes < 60) return `${minutes} min`;
  if (minutes < 24 * 60) {
    const hours = Math.floor(minutes / 60);
    const rest = minutes % 60;
    return rest ? `${hours} h ${rest} min` : `${hours} h`;
  }
  const days = Math.floor(minutes / (24 * 60));
  return days === 1 ? '1 dia' : `${days} dias`;
}

/** Há quanto tempo o comprador espera, na cor do semáforo (prazos da empresa). */
export function WaitBadge({ minutes, band }: { minutes: number | null; band: WaitBand | null }) {
  if (minutes === null || band === null) return null;
  return (
    <StatusBadge tone={WAIT_TONE[band]} icon={band === 'OK' ? Clock : undefined}>
      há {formatWait(minutes)}
    </StatusBadge>
  );
}
